/**
 * Formats a string replacing a comma to dot
 * @param { String } [value=''] string with comma
 * @returns { Number } formatted number
 */
export const replaceCommaToDot = value => Number(value.replace(',', '.'))
